module.exports = __webpack_public_path__ + "media/notification-sound.227c68f3.ogg";